import * as z from "zod";

export const makeSecondaryPaymentMethodPrimary = {
  name: "makeSecondaryPaymentMethodPrimary" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
